import React, { FC, ReactNode, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';
import { ROUTE_SOURCES } from 'src/constants/routeSources';
import { AccountContext, defaultValue } from 'src/providers/account/context';
import { ME } from 'src/utils/gql/queries';
import { Query } from 'src/utils/gql/types';
import { getToken, removeToken } from 'src/utils/localStorage';

export const AccountProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const token = getToken();

  const { data, error } = useQuery<Pick<Query, 'me'>, never>(ME);

  const value = useMemo(() => ({ user: data?.me || defaultValue }), [data?.me]);

  if (error || !token) {
    removeToken();

    return <Navigate to={`/${ROUTE_SOURCES.LOGIN}`} />;
  }

  return (
    <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
  );
};
// test
